import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3fi45855om: FaireBrandEntity = {
  token: "b_3fi45855om",
  type: "brand",
  name: "Moodcast Fragrance Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/e9728a7bf557ce9741e6a12dc44fc3b0aa660099c6adf52d429e2559d3af1025.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/3b0abb3a9750d3753ddbf5e3ab127cf2b2d555ee66739836c6412dc2e1d10744.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e9728a7bf557ce9741e6a12dc44fc3b0aa660099c6adf52d429e2559d3af1025.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3b0abb3a9750d3753ddbf5e3ab127cf2b2d555ee66739836c6412dc2e1d10744.png",
  location: "Dallas, TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 74,
  isTopShop: true,
  isInsider: true,
  description:
    "Moodcast makes custom blended clean fragrances that explore and celebrate the moods, memories and moments that define us.\n\nWe offer fragrances with feeling where each scent is a total mood. Our Persona collection honors all that you are while our Vibes collection brings the most memorable moments back to life.\n\nA portion of all proceeds is donated to children's charities, a cause near and dear to our founder's heart.\n\n*Please note: Moodcast does not allow online selling across any 3rd party platforms such as Amazon, Walmart, Ebay, etc.*",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:46.326Z",
    importedBy: "entity-db-cli",
  },
};
